import m from 'mithril'
import './hamburger.less'
import {Component} from '@codeurs/front'

export default class Hamburger extends Component<{
	isOpen?: boolean
	mod?: string
	class?: string
	onclick: any
}> {
	view() {
		const {class: className, onclick} = this.attrs

		return m('.hamburger',
			{
				className,
				onclick
			},
			[
				m('.hamburger-stripes', [
					m('.hamburger-stripes-stripe'),
					m('.hamburger-stripes-stripe'),
					m('.hamburger-stripes-stripe')
				])
			]
		)
	}
}
